import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { Toaster } from "react-hot-toast";

import AdminLayout from "@/app/layout/AdminLayout";

import DashboardPage from "@/app/dashboard/DashboardPage";
import CarsPage from "@/app/cars/CarsPage";
import AddCarPage from "@/app/cars/AddCarPage";
import BookingsPage from "@/app/bookings/BookingsPage";
import EditPage from "@/app/edit/EditPage";
import EditAboutPage from "@/app/about/AboutPage";
import EditFooterPage from "@/app/footer/FooterPage";
import ForgotPasswordPage from "@/app/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/app/pages/ResetPasswordPage";
import LoginPage from "./app/pages/LoginPage";
import RegisterPage from "./app/pages/RegisterPage";
import ProtectedRoute from "@/app/auth/ProtectedRoute";
import NotificationsPage from "./app/notifications/page";
import EditRegionRatesPage from "@/app/admin/edit-region-rates/page";
import UsersPage from "@/app/users/UsersPage";

import AuditPage from "@/app/audit/AuditPage";

const App = () => {
  return (
    <Router>
      <Toaster position="top-center" reverseOrder={false} />

      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password/:token" element={<ResetPasswordPage />} />

        {/* Redirect root to dashboard */}
        <Route path="/" element={<Navigate to="/dashboard" replace />} />

        {/* Protected routes */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <DashboardPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/users"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <UsersPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/cars"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <CarsPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/cars/add"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <AddCarPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/bookings"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <BookingsPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/edit"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <EditPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/edit/about"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <EditAboutPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/edit/footer"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <EditFooterPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/edit-region-rates"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <EditRegionRatesPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/notifications"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <NotificationsPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/audit"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <AuditPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
};

export default App;
